import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadClearme = createReduxAsyncAction(TYPES.LOAD_CLEARME);
export const clearmeVerify = createReduxAsyncAction(TYPES.CLEARME_VERIFY);
export const setClearModal = createReduxAsyncAction(TYPES.SET_CLEAR_MODAL);
